import React from 'react';
import { View, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';

import SociollaText from '@components/sociolla/SociollaText';
import SelectBox from '@components/form/SelectBox';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import { FILTER_YEARS, MONTH_NAME, MONTH_NAME_SIMPLE } from '@/constants';

// Short names on phones: a full "September" clips inside a ~97px month box.
const MONTHS = (isWeb ? MONTH_NAME : MONTH_NAME_SIMPLE).map((label, index) => ({
  label,
  value: index + 1,
}));

const SalesmanMonthPicker = ({ value, disabled, onChange }) => {
  const year = FILTER_YEARS.find((option) => option.value === value.year);
  const month = MONTHS.find((option) => option.value === value.month);

  return (
    <View style={styles.row}>
      <View style={styles.selector}>
        <SociollaText style={styles.label}>Year</SociollaText>
        <View style={styles.box}>
          <SelectBox
            label="Year"
            hideLabel
            hideSearch
            style={styles.input}
            options={FILTER_YEARS}
            value={year || {}}
            trackBy="value"
            labelKey="label"
            editable={!disabled}
            onChange={(option) => onChange({ ...value, year: option.value })}
          />
        </View>
      </View>

      <View style={styles.selector}>
        <SociollaText style={styles.label}>Month</SociollaText>
        <View style={styles.box}>
          <SelectBox
            label="Month"
            hideLabel
            hideSearch
            style={styles.input}
            options={MONTHS}
            value={month || {}}
            trackBy="value"
            labelKey="label"
            editable={!disabled}
            onChange={(option) => onChange({ ...value, month: option.value })}
          />
        </View>
      </View>
    </View>
  );
};

SalesmanMonthPicker.propTypes = {
  value: PropTypes.shape({
    year: PropTypes.number.isRequired,
    month: PropTypes.number.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

SalesmanMonthPicker.defaultProps = { disabled: false };

const styles = StyleSheet.create({
  box: { flex: 1 },
  // Caps the ~150px intrinsic minimum of the <input> inside SelectBox on web.
  input: { width: '100%' },
  label: { color: Colors.grey13, fontSize: 12, marginRight: 10 },
  // Two across where they fit, stacked where they do not. zIndex lifts the open dropdown
  // above a chart's WebView below it, the same fix the home Business Tracker carries.
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 12,
    marginBottom: 16,
    zIndex: 1,
  },
  selector: {
    alignItems: 'center',
    flexBasis: 130,
    flexDirection: 'row',
    flexGrow: 1,
  },
});

export default SalesmanMonthPicker;
